// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__IJLPD","imageUploader":"EGiftCard_imageUploader__1hr95"};